export const countries = () => 'FNOLSifarnici/GetDrzave?teritorija=1';
export const citizenship = () => 'FNOLSifarnici/GetDrzaveZaDrzavljanstva';
export const cities = () => 'FNOLSifarnici/GetNaselja';
export const policyDetails = () => 'FNOLLife/GetDetaljiPolise';
export const policiesList = () => 'FNOLLife/GetPolise';
export const policiesListForPortal = () => 'FNOLLife/GetListaAktivnihPolisa';
export const bankAccounts = () => 'FNOLSifarnici/GetBanke';
export const insuredTypes = () => 'FNOLSifarnici/GetVrstaOsiguranika';
export const claimSubmit = () => 'FNOLLife/OnlinePrijavaStete';
export const claimConfirmation = () => 'FNOL/PotvrdaPrijaveSteteLista';
export const claimConfirmationAnonymous = () => 'FNOL/PotvrdaPrijaveSteteListaAnonimni';
export const addDocuments = () => 'FNOL/UploadDokumentacije';
export const documents = (id: string) => `FNOL/GetDokumentaZaUpload?stetaTempId=${id}`;
export const userData = () => 'FNOL/GetPodaciOUlogovanomKorisniku';
export const oneTimePassword = () => 'FNOL/GenerisiPrivremenuLozinku';
export const usersList = () => 'FNOLLife/GetKorisnici';
export const contractorData = () => 'FNOLLife/GetUgovarac';
export const offerValidation = () => 'FNOLLife/ProveriPonudu';
